import z from "zod"

export const speciesListTabSchema = z.enum(["recorded", "targeted", "nearby"])

export const speciesListSearchSchema = z.object({
  tab: speciesListTabSchema.catch("recorded").default("recorded").optional(),
})

export type SpeciesListTab = z.infer<typeof speciesListTabSchema>
